<script lang="ts">
	import * as prismic from '@prismicio/client';
	import { SliceZone } from '@prismicio/svelte';
	import { PrismicRichText } from '@prismicio/svelte';
	import { components } from '$lib/slices';
	import { onMount } from 'svelte';
	import { TriggerHeaderColor } from '$lib/helpers/color.trigger';
	import { hideFooter } from '$lib/variable.store';
	hideFooter.set('false');

	export let data;

	onMount(() => {
		if (data.page.data.header_content_color) {
			TriggerHeaderColor(data.page.data.header_content_color);
		}
	});
</script>

<div class="content-wrapper">
	<header class="page__header">
		<div class="container">
			<div class="row">
				<div class="col-12 col-lg">
					<h1 class="page__header--title">{data.title}</h1>
				</div>

				{#if prismic.isFilled.richText(data.page.data.description)}
					<div class="col-12 col-lg-8">
						<div class="page__header--description">
							<PrismicRichText field={data.page.data.description} />
						</div>
					</div>
				{/if}
			</div>
		</div>
	</header>

	<SliceZone slices={data.page.data.slices} {components} />
</div>
